<template>
  <article :class="wrapperClasses">
    <h1>{{title}}</h1>
    <main-media v-if="hasMainMedia" :media="mainMedia" :sizes="mainImageSizes"></main-media>
    <div class="main-info">
      <div class="body" v-html="mainText"></div>
      <div class="secondary" v-if="hasSecondaryText" v-html="secondaryText"></div>
      <icon-list v-if="hasInfoBlock" :items="infoBlock.items"></icon-list>
    </div>
    <section-list v-if="hasSections" :sections="sections" :id="id"></section-list>
  </article>
</template>

<script>
import { mapGetters } from "vuex";
import MainMedia from "./MainMedia";
import SectionList from "./SectionList";
import IconList from "./IconList";
import config from "../config/config";

const emptyPage = () => {
  return {
    id: 0,
    slug: "",
    title: "",
    mainText: "",
    infoBlock: {
      items: []
    },
    hasMainMedia: false,
    secondaryText: "",
    mainMedia: {
      type: "image",
      img: { src: "", caption: "" },
      items: []
    },
    mainImageSizes: [],
    description: "",
    sections: []
  };
};

export default {
  name: "Page",
  components: {
    SectionList,
    MainMedia,
    IconList
  },
  data() {
    return emptyPage();
  },
  created() {
    this.mapPage();
    this.mainImageSizes = config.imageStyles.wide2_41;
  },
  mounted() {
    const hasPages = this.pages instanceof Array && this.pages.length > 0;
    if (!hasPages) {
      this.$parent.getSiteData().then(d => {
        if (d.numPages > 0 && d.pages instanceof Array) {
          this.mapPage(true, d.pages);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["pages"]),
    wrapperClasses() {
      let cls = ["page"];
      if (this.hasInfoBlock || this.hasSecondaryText) {
        cls.push("has-info-block");
      }
      return cls;
    },
    hasSections() {
      return this.sections.length > 0;
    },
    hasInfoBlock() {
      let valid = false;
      if (this.infoBlock.items) {
        if (this.infoBlock.items instanceof Array) {
          valid = this.infoBlock.items.length > 0;
        }
      }
      return valid;
    },
    hasSecondaryText() {
      return this.secondaryText.length > 0;
    },
    pagesLoaded() {
      return this.$parent.pagesLoaded;
    }
  },
  watch: {
    "$route.path"() {
      this.mapPage();
    }
  },
  methods: {
    matchPage(useNewPages, newPages) {
      let page = null;
      const pageList =
        useNewPages === true && newPages instanceof Array
          ? newPages
          : this.pages;
      if (pageList instanceof Array) {
        page = pageList.find(page => "/" + page.slug === this.$route.path);
      }
      return page;
    },
    mapPage(useNewPages, newPages) {
      const page = this.matchPage(useNewPages, newPages);
      if (page) {
        this.mapEmptyPage();
        if (page.post_id) {
          this.id = page.post_id;
        }
        if (page.title) {
          this.title = page.title;
        }
        if (page.mainText) {
          this.mainText = page.mainText;
        }
        if (page.hasMainMedia) {
          this.mainMedia = page.mainMedia;
          this.hasMainMedia = page.hasMainMedia;
        }
        if (page.content) {
          let indices = [];

          let matchedIndex = page.content.findIndex(
            sec => sec.subtype == "iconlist"
          );
          if (matchedIndex >= 0) {
            this.infoBlock = page.content[matchedIndex];
            indices.push(matchedIndex);
          }
          matchedIndex = page.content.findIndex(
            sec => sec.subtype == "secondary"
          );
          if (matchedIndex >= 0) {
            this.secondaryText = page.content[matchedIndex].markup;
            indices.push(matchedIndex);
          }
          this.sections = page.content.filter(
            (sec, secIndex) => indices.indexOf(secIndex) < 0
          );
        }
      }
    },
    mapEmptyPage() {
      const emptyData = emptyPage();
      const keys = Object.keys(emptyData);
      const nk = keys.length;
      for (let i = 0; i < nk; i++) {
        let k = keys[i];
        this.$set(this, k, emptyData[k]);
      }
    }
  }
};
</script>
